import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=3581e181&scoped=true"
import script from "./PhoneInput.vue?vue&type=script&lang=js"
export * from "./PhoneInput.vue?vue&type=script&lang=js"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=3581e181&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581e181",
  null
  
)

export default component.exports